import React from "react";

const ShareComponent = () => {
  return <div></div>;
};

export default ShareComponent;
